export const USER_TITLE = {
    manager: 'Manager',
    admin: 'Admin',
    onsite_manager: 'Onsite Manager'
}

export const SIGN_UP_SOURCE_UNUM = {
    web_portal: 'web_portal',
    mobile_app: 'mobile_app'
}